// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3w2YY","containerItemsCenter":"Skeleton_containerItemsCenter__tyHIL"};